import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: BASE,
    withCredentials: true,
});

// On a 401, try one silent refresh (the backend rotates the httpOnly cookie),
// then replay the original request. Never loops on the auth endpoints themselves.
let refreshPromise = null;
api.interceptors.response.use(
    (res) => res,
    async (error) => {
        const original = error.config || {};
        const status = error.response?.status;
        if (status === 401 && !original._retry && !(original.url || "").includes("/auth/")) {
            original._retry = true;
            refreshPromise =
                refreshPromise ||
                axios.post(`${BASE}/auth/refresh`, {}, { withCredentials: true }).finally(() => {
                    refreshPromise = null;
                });
            try {
                await refreshPromise;
                return api(original);
            } catch {
                // refresh failed — surface the 401
            }
        }
        return Promise.reject(error);
    }
);
